import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ServicesSection.css";
import productsData from '../products.json';

const ServicesSection = () => {
  // استخراج مصفوفة الخدمات من ملف الـ JSON
  const services = productsData.services || [];

  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
  const sectionEl = sectionRef.current;

  const observer = new IntersectionObserver(
    ([entry]) => {
      // الشرط هنا: يفعل الأنيميشن فقط لو السكشن ظاهر فعلياً في الشاشة
      if (entry.isIntersecting) {
        setVisible(true);
        observer.unobserve(entry.target); // يوقف المراقبة بعد أول ظهور
      }
    },
    { 
      threshold: 0.2, // لازم 20% من السكشن يدخل الشاشة عشان الأنيميشن يشتغل
      rootMargin: "0px" 
    }
  );

  if (sectionEl) observer.observe(sectionEl);

  return () => {
    if (sectionEl) observer.unobserve(sectionEl);
  };
}, []);

  return (
    <section id="services" className="services-section" ref={sectionRef}>
      <Container>
        {/* 🌟 الهيدر 🌟 */}
        <Row className="justify-content-center mb-5">
          <Col lg={8} className={`text-center fade-down ${visible ? "visible" : ""}`}>
            <h2 className="section-title">خدماتنا</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              مجموعة متكاملة من حلول أمان المسابح، النوافير الشفافة، والتصاميم المخصصة التي تلبي جميع الاحتياجات
            </p>
          </Col>
        </Row>
        
        {/* 🌟 الكروت تظهر بالتتابع 🌟 */}
        <Row>
          {services.map((service, index) => (
            <Col
              md={6}
              lg={4}
              className={`mb-4 fade-up ${visible ? "visible" : ""}`}
              key={index}
              style={{ transitionDelay: `${0.3 + index * 0.3}s` }}
            >
              <div className="service-card">
                <div className="service-icon-wrapper">
                  <i className={`${service.icon} service-icon`}></i>
                </div>
                <h5 className="service-title">{service.title}</h5>
                <p className="service-desc">{service.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;